import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	SCHOLARSHIP_SESSION_FEATURE_KEY,
	ScholarshipSessionState,
	ScholarshipSessionPartialState,
	scholarshipSessionAdapter
} from './scholarshipsession.reducer';

// Lookup the 'ScholarshipSession' feature state managed by NgRx
export const getScholarshipSessionState = createFeatureSelector<
	ScholarshipSessionPartialState,
	ScholarshipSessionState
>(SCHOLARSHIP_SESSION_FEATURE_KEY);

const { selectAll, selectEntities } = scholarshipSessionAdapter.getSelectors();

export const getScholarshipSessionLoaded = createSelector(
	getScholarshipSessionState,
	(state: ScholarshipSessionState) => state.loaded
);

export const getScholarshipSessionError = createSelector(
	getScholarshipSessionState,
	(state: ScholarshipSessionState) => state.error
);

export const loadingScholarshipSession = createSelector(
	getScholarshipSessionState,
	(state: ScholarshipSessionState) => state.loaded
);

export const getAllScholarshipSession = createSelector(getScholarshipSessionState, (state: ScholarshipSessionState) =>
	selectAll(state)
);

export const getScholarshipSessionEntities = createSelector(
	getScholarshipSessionState,
	(state: ScholarshipSessionState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getScholarshipSessionState,
	(state: ScholarshipSessionState) => state.selectedScholarshipSessionId
);

export const getSelected = createSelector(
	getScholarshipSessionEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
